import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../common/CustomComponents/RowContainer';

const Support = () => {
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
    return (
      tenantLayouts['support'] && 
        <div className={tenantLayouts['support'].className} id={tenantLayouts['support'].id}>
        {tenantLayouts['support'].sections.map((item,index) =>{
          return <RowContainer key={index} {...item} />;
        })}
        </div>
    );
};

export default Support;